import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import Config from '../../../../Config';
import { connect } from 'react-redux';
import Payment from '../Partials/Payment/Payment';
import PopUpPaymentError from '../Partials/Payment/PopUpPaymentError/PopUpPaymentError';
import SuccessMsg from '../Partials/Payment/SuccessMsg/SuccessMsg';
import ErrorMsg from '../Partials/Payment/ErrorMsg/ErrorMsg';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, resetCgIframeUrl, reportDWH } from '../saleJetBlockSlice';
import { getEMVStep1, getEMVStep2, createSaleAsync } from '../saleBlockAsyncThunk';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../../utilities/analytics/tracking';


const PaymentPage = (props) => {
  const [isDisplayErrorPopup, setIsDisplayErrorPopup] = useState(false);
  const [errorPopupContent, setErrorPopupContent] = useState({title: '', subTitle: ''});
  const [step, setStep] = useState('payment');
  const [isDisplayFooter, setIsDisplayFooter] = useState(false);
  //const [isTermsCheckboxChecked, setIsTermsCheckboxChecked] = useState(false);
  //const [isDisplayCheckboxErrorMsg, setIsDisplayCheckboxErrorMsg] = useState(false);

  useEffect(() => {
    props.reportDWH({ actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Card Info Page Displayed' });
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step13_PaymentMethodPage' : `${props.saleType}_Step9_PaymentMethodPage`,
      step: props.saleType == 'cellular' ? '13' : '9',
      action: 'PaymentMethodPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }, []);

  //page params
  let btnText = 'אישור תשלום';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const cellularStep = props.flowType == 'existsCustomer' ? '14' : '13'
  var handler;
  //page params

  useExtendedEffect((runSideEffects) => {
    getCgUrl();
    if (!runSideEffects()) {
    }
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      {
        step == 'payment' &&
        <>
          <h1 className='sale-title-big'>עדכון אמצעי תשלום</h1>
          <h2 className='sale-title-small'>אמצעי התשלום של תעודת זהות שנרשמת איתה</h2>
        </>
      }
      {
        step == 'loader' &&
        <>
          <h1 className='sale-title-big'>אוטוטו מסיימים</h1>
          <h2 className='sale-title-small'>יש להזין את אמצעי התשלום השייך למספר תעודת הזהות שהזנת בתחילה</h2>
        </>
      }
      {
        step == 'success' &&
        <>
          <h1 className='sale-title-big'>אוטוטו מסיימים</h1>
        </>
      }
      {
        step == 'error' &&
        <>
          <h1 className='sale-title-big'>השלמת הזמנה</h1>
        </>
      }
    </div>
  );

  let currentPageView = (
    <div>
      {step == 'payment' && <Payment />}
      {step == 'success' && <SuccessMsg termsLink={props.termsLink} /*isDisplayCheckboxErrorMsg={isDisplayCheckboxErrorMsg} onClickTermsCheckbox={onClickTermsCheckbox} isTermsCheckboxChecked={isTermsCheckboxChecked}*/ />}
      {step == 'error' && <ErrorMsg onclickTryAgainBtn={getCgUrl} />}
      <PopUpPaymentError isDisplayErrorPopup={isDisplayErrorPopup} content={errorPopupContent} closePopUp={closePopUp} onclickTryAgainBtn={onclickTryAgainBtn} />
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  async function getCgUrl() {
    setIsDisplayFooter(false);
    setStep('payment');
    props.getEMVStep1();
    addEventListener();
  }

  async function getCgConfirmation(token, identity) {
    setStep('loader');
    const result = await props.getEMVStep2({ token: token, id: identity });
    if (result.payload.returnCode == '00') {
      setIsDisplayFooter(true);
      setStep('success');
    }
    else {
      if(result.payload.errorCode == '803') {
        setErrorPopupContent({title: 'מצטערים, לא ניתן להשתמש באמצעי תשלום מסוג דיירקט' , subTitle: 'אפשר להחליף לכרטיס אשראי מסוג אחר'});
        setIsDisplayErrorPopup(true);
        props.reportDWH({ actionType: 'Credit Card Info', status: 'Error', messageText: 'Credit Card Not Valid Error - Debit' });
      }
      else{
        setStep('error');
      }
    }
  }

  /*
  function onClickTermsCheckbox() {
    setIsTermsCheckboxChecked(!isTermsCheckboxChecked);
    if (!isTermsCheckboxChecked) {
      setIsDisplayCheckboxErrorMsg(false);
    }
  }
  */

  function closePopUp() {
    setIsDisplayErrorPopup(false);
  }

  function onclickTryAgainBtn() {
    getCgUrl();
    setIsDisplayErrorPopup(false);
  }

  function handlePageContinue() {
    props.goToPage('createSaleInProcess');
    props.reportDWH({ actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Card Info Button Clicked' });
    gtag4({
      event: props.saleType == 'cellular' ? `cellular_Step${cellularStep}_PaymentMethodButton` :  `${props.saleType}_Step9_PaymentMethodButton`,
      step: props.saleType == 'cellular' ? cellularStep : '9',
      button: btnText,
      action: 'PaymentMethodButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
    /*
    if (isTermsCheckboxChecked) {
      props.goToPage('createSaleInProcess');
      props.reportDWH({ actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Card Info Button Clicked' });
    }
    else {
      setIsDisplayCheckboxErrorMsg(true);
    }
    */
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function addEventListener() {
    //listen to iframe messages from cg
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

    handler = function (e) {
      var isSuccess = e.data.status == 'success';
      var isError = e.data.status == 'error';

      if (isSuccess) {
        props.resetCgIframeUrl();
        if (Config.cgShowIdNumber == "True" && (props.identity != "" && e.data.personalId != props.identity)) {
          setErrorPopupContent({title: 'מצטערים, משהו השתבש \nוהעסקה לא בוצעה בהצלחה!' , subTitle: 'תעודת הזהות שהזנתם לא תואמת לפרטים איתם הזדהתם בתחילת התהליך.'});
          setIsDisplayErrorPopup(true);
          props.reportDWH({ actionType: 'Credit Card Info', status: 'Error', messageText: 'Credit Card Not Valid Error' });
        }
        else {
          getCgConfirmation(e.data.token, e.data.personalId);
        }
        removeListener();
      }
      else if (isError) {
        props.resetCgIframeUrl();
        setErrorPopupContent({title: 'מצטערים, משהו השתבש \nוהעסקה לא בוצעה בהצלחה!' , subTitle: 'האשראי שהוזן לא תואם לבעל תעודת זהות או שהזנתם מספר כרטיס אשראי שגוי.'});
        setIsDisplayErrorPopup(true);
        removeListener();
        props.reportDWH({ actionType: 'Credit Card Info', status: 'Error', messageText: 'Credit Guard Error' });
      }
      return;
    };

    eventer(messageEvent, handler);
  }

  function removeListener() {
    var cond = window.addEventListener;
    window[cond ? 'removeEventListener' : 'detachEvent'](cond ? 'message' : 'onmessage', handler);
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    identity: state.saleJetBlock.personalInfo.identity,
    termsLink: state.saleJetBlock.saleBlockData.termsLink,
    totalPrice: state.saleJetBlock.totalPrice

    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  getEMVStep1,
  getEMVStep2,
  showAppLoader,
  hideAppLoader,
  createSaleAsync,
  resetCgIframeUrl,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
